// Ver un video adjunto en grande y reproducirlo —
// ADR-2026-10-20-el-video-adjunto-se-ve-y-se-reproduce.
//
// El adjunto guarda el PATH, no una URL (las firmas vencen): se firma al tocarlo. Lo usan el
// chip de la caja del chat y la tarjeta "Añadir referencia" de Crear, con el mismo visor que
// las fotos del mensaje (`VisorDeAdjunto`, portal a body).

import { useCallback, useRef, useState } from 'react';
import { signReferenceImage } from '../../pages/v2/agentAttachments';
import { VisorDeAdjunto } from '../../pages/v2/components/VisorDeAdjunto';

/** Lo mínimo para verlo: sirve el adjunto del chat y el que quedó guardado en el mensaje. */
type VideoAdjunto = { storagePath: string; bucket?: string; name: string };

export function useVerVideoAdjunto() {
  const [abierto, setAbierto] = useState<{ url: string; nombre: string } | null>(null);
  // El último pedido gana: dos toques seguidos no abren el primero cuando llega tarde.
  const pedido = useRef(0);
  const ver = useCallback(async (v: VideoAdjunto) => {
    const n = ++pedido.current;
    const url = await signReferenceImage(v.storagePath, v.bucket).catch(() => null);
    if (url && n === pedido.current) setAbierto({ url, nombre: v.name });
  }, []);
  const visor = abierto ? (
    <VisorDeAdjunto url={abierto.url} nombre={abierto.nombre} tipo="video" onCerrar={() => setAbierto(null)} />
  ) : null;
  return { ver, visor };
}
